import React from "react";
import { Route, Redirect } from "react-router-dom";

import { TAXIDERMY_BLOCKED_PATHS } from "./memberProfile";

// Steers taxidermy-only members back to /taxidermy. This is a <Route> rather
// than a window.location check so it re-runs on every navigation - a check
// evaluated during App's render never sees an in-app <Link> click, because
// App does not re-render when only the router location changes.
const TaxidermyGate = ({ active }) => {
  if (!active) {
    return null;
  }

  return (
    <Route path={TAXIDERMY_BLOCKED_PATHS}>
      <Redirect to="/taxidermy" />
    </Route>
  );
};

export default TaxidermyGate;
